import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDartIcon = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 89,
	height: 88,
	viewBox: "0 0 89 88",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M84.375 44C84.375 66.0224 66.5224 83.875 44.5 83.875C22.4776 83.875 4.625 66.0224 4.625 44C4.625 21.9776 22.4776 4.125 44.5 4.125C66.5224 4.125 84.375 21.9776 84.375 44ZM13.2611 44C13.2611 61.2527 27.2473 75.2389 44.5 75.2389C61.7527 75.2389 75.7389 61.2527 75.7389 44C75.7389 26.7473 61.7527 12.7611 44.5 12.7611C27.2473 12.7611 13.2611 26.7473 13.2611 44Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 44.4995,
			cy: 44,
			r: 18.48,
			fill: "#ACD4FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M76.8513 5.99767C74.3545 3.50078 70.3063 3.50078 67.8095 5.99767L58.2026 15.6048C54.729 19.0786 54.2292 24.4 56.7034 28.4054L42.4522 42.657C41.5159 43.5933 41.5159 45.1114 42.4522 46.0477C43.3885 46.9841 44.9066 46.9841 45.8429 46.0477L60.0938 31.7965C64.0992 34.2717 69.4214 33.7723 72.8955 30.2982L82.5024 20.691C84.9992 18.1941 84.9992 14.1458 82.5024 11.6489L76.8513 5.99767Z",
			fill: "#002E5F"
		})
	]
});
const ForwardRef = forwardRef(SvgDartIcon);
export default ForwardRef;
